import { Api } from '../../api'
import { LeadRequest, LeadRequestData, LeadRequestType, LeadRequestServiceI } from '../../../index.d'

export class LeadRequestService implements LeadRequestServiceI {
  /**
   * Create lead request
   * @param {LeadRequestType} type
   * @param {LeadRequestI['context']} context
   */
  createLeadRequest(type: LeadRequestType, context: LeadRequest['context'], data: LeadRequestData = {}): LeadRequest {
    return Object.assign(
      {
        type,
        agreement: true,
        context,
      },
      data
    )
  }

  /**
   * Send lead request with specific data
   * @param {LeadRequestData} data
   * @param {LeadRequestI['context']} context
   * @param {string} urlGetParams
   * @param {LeadRequestType.External} type
   */
  async send(learRequest: LeadRequest, urlGetParams = ''): Promise<unknown> {
    const { data } = await Api.post<unknown>(`/api/lead_requests${urlGetParams}`, {
      lead_request: learRequest,
    })

    return data
  }
}
